// extracted by mini-css-extract-plugin
export default {"MigrationItem":"migration-create-item_MigrationItem__SLeX7","migrationRow":"migration-create-item_migrationRow__V3ZUt","DateBlock":"migration-create-item_DateBlock__+djAI"};